document.addEventListener('DOMContentLoaded', function () {
    const viewMoreBtn = document.getElementById('view-more-btn');
    const expandableGrid = document.querySelector('.custom-grid-container');
    const mask = document.querySelector('.gradient-mask');
    const grid = document.getElementById('devices-grid')

    viewMoreBtn.addEventListener('click', function () {
      
      expandableGrid.classList.toggle('masked');

      if (expandableGrid.classList.contains('masked')) {
            viewMoreBtn.textContent = 'View all'
              if (viewMoreBtn.classList.contains('accent') ==  false) {
                  viewMoreBtn.classList.toggle('accent')
                  //document.body.scrollTop = 0; // For Safari
                  //document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                  console.log(grid);
                  grid.scrollIntoView({ behavior: "smooth"});
                }
        } else {
            viewMoreBtn.textContent = 'View less'
            viewMoreBtn.classList.toggle('accent')
      };
        
      mask.classList.toggle('hidden');

    });
  
});